/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboCashManagementBadRequestResponse,
  BboCashManagementForbiddenResponse,
  BranchCashOverviewResponseResponse,
  FailureResponseResponse,
  NotFoundResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * Get cumulative cash details across all accounting location with association details as              well. Endpoint will get declared cash details (current variance and to date variance) for            all accounting locations. It will respond will data segregated based on counter                     association with cash drawers.
 * @summary Get cumulative cash details across all accounting location with association details as well.
 */
export const getCashBranchOverviewDetails = (signal?: AbortSignal) => {
  return customInstance<BranchCashOverviewResponseResponse>({
    url: `/BboCashManagementService/v1/branch-overview`,
    method: 'get',
    signal,
  });
};

export const getGetCashBranchOverviewDetailsQueryKey = () => {
  return [`/BboCashManagementService/v1/branch-overview`] as const;
};

export const getGetCashBranchOverviewDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCashBranchOverviewDetails>>,
  TError = ErrorType<
    | BboCashManagementBadRequestResponse
    | UnauthorizedResponse
    | BboCashManagementForbiddenResponse
    | NotFoundResponse
    | FailureResponseResponse
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getCashBranchOverviewDetails>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCashBranchOverviewDetailsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCashBranchOverviewDetails>>> = ({
    signal,
  }) => getCashBranchOverviewDetails(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCashBranchOverviewDetails>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCashBranchOverviewDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCashBranchOverviewDetails>>
>;
export type GetCashBranchOverviewDetailsQueryError = ErrorType<
  | BboCashManagementBadRequestResponse
  | UnauthorizedResponse
  | BboCashManagementForbiddenResponse
  | NotFoundResponse
  | FailureResponseResponse
>;

/**
 * @summary Get cumulative cash details across all accounting location with association details as well.
 */
export const useGetCashBranchOverviewDetails = <
  TData = Awaited<ReturnType<typeof getCashBranchOverviewDetails>>,
  TError = ErrorType<
    | BboCashManagementBadRequestResponse
    | UnauthorizedResponse
    | BboCashManagementForbiddenResponse
    | NotFoundResponse
    | FailureResponseResponse
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getCashBranchOverviewDetails>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCashBranchOverviewDetailsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
